module.exports = __webpack_public_path__ + "img/423b4bd17473653abb624580367d21de.9a3ce6b0.png";